import { render } from "./TheTransition.vue?vue&type=template&id=bdfa31de"
const script = {}

import "./TheTransition.vue?vue&type=style&index=0&id=bdfa31de&lang=css"

import exportComponent from "F:\\Softwaresul\\Projetos Node\\LWP\\Nil Key\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__